import { render } from "./HeadingTabs.vue?vue&type=template&id=2d2b4e7c&scoped=true"
import script from "./HeadingTabs.vue?vue&type=script&lang=js"
export * from "./HeadingTabs.vue?vue&type=script&lang=js"

import "./HeadingTabs.vue?vue&type=style&index=0&id=2d2b4e7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2b4e7c"]])

export default __exports__